<template>
   <div>
      <HeaderInnerPage
         id="how-works"
         title="Cartilha para o Anfitrião"
         :background="bgPage"
      >
      </HeaderInnerPage>

      <section class="cartilha-warp">
         <b-container>
            <b-row class="mt-0 mt-lg-3" align-h="center">
               <b-col cols="12" md="8" class="bg-secondary p-4 p-md-5 cartilha-body rounded-lg shadow-lg">
                  <h1><em><span style="font-family:Times New Roman,Times,serif">Ol&aacute;, anfitrião!</span></em></h1>

                   <p class="lead">Antes de compartilhar a sua bicicleta com alguém, queremos dividir com você algumas dicas para proporcionar uma boa experiência aos ciclistas que usarão a sua bike.</p>

                  <h3>MANUTENÇÃO</h3><br>

                  <ul class="list-cartilha">
                     <li> <strong>Freios</strong> <br>Se perceber alguma dificuldade na frenagem (sapata desalinhada, solta, gasta ou com pressão inadequada), leve a bicicleta ao mecânico.</li>
                     <li> <strong>Ajustes</strong> <br>É fundamental que todas as partes da bicicleta estejam bem fixadas — guidão, selim, rodas, pedal, etc. Se perceber algum ruído estranho ou mau funcionamento da bicicleta que você não consegue resolver, leve-a para manutenção profissional.</li>
                     <li> <strong>Corrente</strong> <br>Lubrifique a corrente com óleo apropriado. Não se esqueça de tirar a sujeira antes.</li>
                     <li> <strong>Rodas</strong> <br>A bicicleta perde rapidamente a calibragem. Evite pneus murchos, pois exigem maior esforço
                        físico do ciclista, e também pneus muito cheios, que dão menos aderência e causam desconforto ao pedalar. Siga a recomendação do fabricante para enchê-los.</li>
                  </ul>



                     <h3>ACESSÓRIOS OBRIGATÓRIO</h3><br>

                     <strong><em>Fique atento, alguns acessórios são obrigatórios na bicicleta, segundo o Código de Trânsito Brasileiro. Confira quais são eles a seguir.</em></strong>
                  <br>
                  <br>

                  <ul class="list-cartilha">
                     <li> <strong>Sinalizações noturnas reflexivas:</strong> a sinalização dianteira deve ser na cor branca, a traseira na cor vermelha, os pedais e laterais na cor amarela ou branca. Mantenha-as limpas para que possam refletir a luz.</li>
                     <li> <strong>Campainha:</strong> a campainha deve ser de boa qualidade para permitir que os outros usuários identifiquem a bicicleta no trânsito e fiquem atentos.</li>
                     <li> <strong>Espelho retrovisor:</strong> deve ser colocado um espelho retrovisor pelo menos do lado esquerdo.
                        Escolha um acessório de qualidade, que permita a visualização do que acontece atrás do
                        ciclista. O material deste equipamento deve ser de plástico para não oferecer risco.</li>
                  </ul>



                     <h3>RETIRADA DA BIKE PELO CICLISTA</h3><br>


                    <p>Na hora de entregar a sua bike para o(a) ciclista, usar um cadeado com senha é uma boa alternativa. É só combinar o local de retirada, o horário e informar a senha para ele(a) buscar a bicicleta.</p>


<!--                     <h3>COMO PRENDER A BICICLETA</h3><br />


                    <p><strong>Para sua bike ficar mais segura e você mais tranquilo, temos mais dicas de como prender a bicicleta.</strong></p>


                  <ol class="list-cartilha">
                     <li>Certifique-se de que o paraciclo em que você vai amarrar a bicicleta esteja bem firme, preso ao chão.</li>
                     <li> Prenda a roda traseira e o quadro junto ao paraciclo.</li>
                     <li> Use um cabo de aço ou trava tipo U-Lock para prender a roda dianteira e o selim, passando por dentro do quadro. Se possível, dê preferências a trava tipo U-Lock, em formato de U, que aumenta muito a segurança da bicicleta por ser mais difícil de abrir que um cabo de aço tradicional.</li>
                     <li> Rodas que possuem sistema de desengate rápido (Quick Release) precisam estar presas. O mesmo acontece com o selim. Ele pode ser retirado e levado com você.</li>
                     <li> Retire da bike os acessórios que podem ser facilmente levados.</li>
                  </ol>-->

                  <p><strong>Agora sim, você está preparado para compartilhar sua bicicleta e ela está pronta para passear pela cidade na companhia de outro ciclista.</strong></p>

                  <img class="img-fluid" :src="imgCartilha" alt="">

               </b-col>
            </b-row>
         </b-container>
      </section>


      <CallToActionSection
         class="mt-5"
         title="Quer alugar sua bicicleta?"
         desc="É fácil, rápido e seguro alugar sua bicicleta."
         textLink="ANUNCIAR BICICLETA"
         link="/registrar"

      />

   </div>
</template>

<script>
import bgPage from '@/assets/img/cartilha-anunciante.jpg';
import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
import CallToActionSection from "@/components/CallToActionSection";
import {metaTags} from "@/helpers";
import imgCartilha from "@/assets/img/entenda-como-funciona-pedale-img.svg";


export default {
   name: 'Help',
   metaInfo: metaTags(`Cartilha para o Anfitrião`),
   components: {
      HeaderInnerPage,
      CallToActionSection
   },
   data() {
      return {
         bgPage,
         imgCartilha
      }
   },
}
</script>

<style lang="scss">

</style>
